






























import Vue from 'vue'
export default Vue.extend({
  data: () => ({
    items: [
      { title: 'Журнал', icon: 'list', href: { name: 'RecordingList' } },
      {
        title: 'Программы',
        icon: 'schedule',
        href: { name: 'ProgramList' },
      },
      { title: 'Потоки', icon: 'http', href: { name: 'StreamList' } },
    ],
  }),
})
